export default __webpack_public_path__ + "028b49d0d132922ef8c0f743f759a66c.png";